const mobileAppClients = [
    "8stringtv",
    "akaku",
    "andover",
    "aurora",
    "avon-lake",
    "cantv",
    "charlestown",
    // 'city-of-marathon',
    // 'cmtv14',
    // 'etvlive',
    "fridley",
    "frostburgtv3",
    // 'hsv-tv',
    // 'kltv',
    "kputv",
    "missoula",
    "monroe",
    "olympia",
    "shoreline",
    "tbnk",
    "thumbcoast",
    "tyngsborough",
    "waycam",
    "westchester",
    "westfordcat",
    "ripon",
    "san-leandro",
    "epping",
    "pflugerville",
]

export const checkIfClientHasMobileApp = (client) => mobileAppClients.includes(client)
